<template>
  <v-dialog v-model="dialogVisible" width="400" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn text v-bind="$attrs" v-on="on">von Kurs </v-btn>
    </template>
    <v-card>
      <v-system-bar window
        >Kurs auswählen<v-spacer /><v-icon @click="close"
          >mdi-close</v-icon
        ></v-system-bar
      >
      <v-toolbar flat>
        <CoursePartInput
          v-model="pickerValue"
          label="Kurse suchen"
          clearable
          hide-details
          @input="add"
      /></v-toolbar>
      <v-divider />
      <v-card-text class="pa-0 ma-0">
        <v-list>
          <v-list-item-group v-model="modelValue">
            <Course v-for="item in items" :key="item.id" :value="item" />
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="" text @click="close">Abbrechen</v-btn>
        <v-spacer />
        <v-btn
          color="success"
          text
          @click="accept"
          :disabled="modelValue == null"
          >Mitglieder hinzufügen</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { defineComponent } from "vue";
import Course from "@/components/Course.vue";
import CoursePartInput from "common/components/CoursePartInput.vue";

export default defineComponent({
  name: "PersonCoursePicker",
  components: { Course, CoursePartInput },
  props: {
    value: { type: Array },
  },
  data() {
    return {
      dialogVisible: false,
      items: [],
      modelValue: this.value,
      pickerValue: null,
    };
  },
  async created() {
    this.items = await this.apiList({
      resource: "course/coursepart",
      query: `person=${this.$_profilePerson.id}&startDate=${this.$_currentTerm.startDate}&endDate=${this.$_currentTerm.endDate}`,
    });
  },
  methods: {
    accept() {
      if (this.modelValue) {
        this.$emit("input", this.modelValue);
        this.close();
      }
    },
    add(item) {
      if (item) {
        this.items.unshift(item);
        this.modelValue = item;
        window.setTimeout(() => (this.pickerValue = null), 100);
      }
    },
    close() {
      this.dialogVisible = false;
    },
  },
});
</script>
